import type { MegaCategoryColumn, MegaLinkItem } from '../data/navMegaMock';
import type { ContentCategoryPublic } from '../types';
import { getImageUrl } from './imageUtils';

const COLS = 3;

/**
 * ستون‌های مگامنو «دوره‌ها»: لینک کاوش، لیست کلاسیک، سپس دسته‌های واقعی با ?cat=slug
 */
export function buildCourseMegaColumns(categories: ContentCategoryPublic[]): MegaCategoryColumn[] {
  const sorted = [...categories]
    .filter((c) => c.isActive !== false && c.slug?.trim() && !c.browseLandingIntro)
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.name.localeCompare(b.name, 'fa'));

  const fixed: MegaLinkItem[] = [
    {
      id: 'course-mega-browse',
      label: 'کتابخانه دوره‌ها',
      description: 'همهٔ دوره‌ها؛ جستجو، دسته‌بندی، فیلتر و چیدمان',
      href: '/courses',
    },
  ];

  const fromApi: MegaLinkItem[] = sorted.map((c) => {
    const n = c._count?.courses ?? 0;
    const thumb = getImageUrl(c.image);
    return {
      id: `cat-${c.id}`,
      label: c.name,
      description: (c.shortDescription?.trim() || c.description?.trim()?.slice(0, 92) || 'مشاهده دوره‌های این دسته').replace(
        /\s+/g,
        ' ',
      ),
      href: `/courses?cat=${encodeURIComponent(c.slug)}`,
      badge: n > 0 ? n.toLocaleString('fa-IR') : undefined,
      thumbnailUrl: thumb ?? undefined,
    };
  });

  const all = [...fixed, ...fromApi];
  const chunkSize = Math.max(1, Math.ceil(all.length / COLS));

  const cols: MegaCategoryColumn[] = [];
  for (let i = 0; i < COLS; i++) {
    const items = all.slice(i * chunkSize, (i + 1) * chunkSize);
    if (!items.length) break;
    cols.push({
      id: `course-mega-col-${i}`,
      title: i === 0 ? 'مسیرها و دسته‌ها' : 'ادامهٔ فهرست',
      subtitle:
        i === 0 ? `${sorted.length.toLocaleString('fa-IR')} دستهٔ فعال` : `${items.length.toLocaleString('fa-IR')} مورد`,
      items,
    });
  }

  return cols.length ? cols : [{ id: 'course-mega-fallback', title: 'دوره‌ها', subtitle: '', items: fixed }];
}
